import { Routes, Route } from 'react-router-dom';
import { TournamentProvider } from '../mobile/TournamentContext';
import { AppPrefixProvider } from '../mobile/AppPrefixContext';
import { ScorerAuthGate } from '../mobile/ScorerApp';
import ScorerHome from '../mobile/pages/scorer/ScorerHome';
import ScorerGroupsPage from '../mobile/pages/scorer/ScorerGroupsPage';
import ScorerGroupScoreEntry from '../mobile/pages/scorer/ScorerGroupScoreEntry';

export default function Scorer() {
  return (
    <AppPrefixProvider prefix="/scorer">
      <TournamentProvider>
        <div className="min-h-screen bg-gray-50">
          <div className="max-w-2xl mx-auto">
            <Routes>
              <Route index element={<ScorerAuthGate><ScorerHome /></ScorerAuthGate>} />
              <Route path="groups" element={<ScorerAuthGate><ScorerGroupsPage /></ScorerAuthGate>} />
              <Route path="group/:groupNumber" element={<ScorerAuthGate><ScorerGroupScoreEntry /></ScorerAuthGate>} />
            </Routes>
          </div>
        </div>
      </TournamentProvider>
    </AppPrefixProvider>
  );
}
